// eslint-disable-next-line no-restricted-imports
import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';

export enum EntityType {
	SITE = 'site',
	USER = 'user',
	SITE_USER = 'site_user',
}

type fetchSitePersonalizationParams = {
	entityType: EntityType.SITE;
	cloudId: string;
};

type fetchUserPersonalizationParams = {
	entityType: EntityType.USER;
	userId: string;
};

type fetchSiteUserPersonalizationParams = {
	entityType: EntityType.SITE_USER;
	cloudId: string;
	userId: string;
};

type fetchPersonalizationParams =
	| fetchSitePersonalizationParams
	| fetchUserPersonalizationParams
	| fetchSiteUserPersonalizationParams;

const fetchPersonalization = async (
	network: Parameters<ExperimentalQueries['experimentalSiteUserPersonalization']>[2]['network'],
	params: fetchPersonalizationParams,
) => {
	const { entityType } = params;
	let endpoint = '/gateway/api/tap-delivery/api/v3/personalization/';
	if (entityType === EntityType.SITE) {
		endpoint += `site/${params.cloudId}`;
	} else if (entityType === EntityType.USER) {
		endpoint += `user/${params.userId}`;
	} else if (entityType === EntityType.SITE_USER) {
		endpoint += `site/${params.cloudId}/user/${params.userId}`;
	}

	try {
		const res = await network.cfetch(endpoint, {
			method: 'GET',
		});
		return await res.json();
	} catch (error) {
		throw error;
	}
};

export const experimentalSitePersonalization: ExperimentalQueries['experimentalSitePersonalization'] =
	async (_, { cloudId }, { network }) => {
		return fetchPersonalization(network, { entityType: EntityType.SITE, cloudId });
	};

export const experimentalUserPersonalization: ExperimentalQueries['experimentalUserPersonalization'] =
	async (_, { userId }, { network }) => {
		return fetchPersonalization(network, { entityType: EntityType.USER, userId });
	};

export const experimentalSiteUserPersonalization: ExperimentalQueries['experimentalSiteUserPersonalization'] =
	async (_, { cloudId, userId }, { network }) => {
		return fetchPersonalization(network, { entityType: EntityType.SITE_USER, cloudId, userId });
	};
